import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import type { CookieConsentConfig } from 'vanilla-cookieconsent';

const config: CookieConsentConfig = {
    disablePageInteraction: true,
    guiOptions: {
        consentModal: {
            layout: 'box',
            position: 'bottom right',
        },
        preferencesModal: {
            layout: 'box',
        },
    },

    onFirstConsent: () => {
        console.log('onFirstAction fired');
    },

    onConsent: () => {
        console.log('onConsent fired ...');
    },

    onChange: () => {
        console.log('onChange fired ...');
    },

    categories: {
        necessary: {
            readOnly: true,
            enabled: true,
        },
        analytics: {
            autoClear: {
                cookies: [
                    {
                        name: /^(_ga|_gid)/,
                    },
                ],
            },
        },
        ads: {},
    },

    language: {
        default: 'en',
        translations: {
            en: {
                consentModal: {
                    title: "Hello traveller, it's cookie time!",
                    description:
                        'Our website uses essential cookies to ensure its proper operation.',
                    acceptAllBtn: 'Accept',
                    acceptNecessaryBtn: 'Reject',
                    showPreferencesBtn: 'Manage preferences',
                },
                preferencesModal: {
                    title: 'Cookie preferences',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Save preferences',
                    sections: [
                        {
                            title: 'Strictly necessary cookies',
                            description:
                                'These cookies are necessary for the website to function. These cookies are used compulsorily in order to fulfill an information society service requested by the user (such as logging in, filling in forms, remembering privacy preferences).',
                            linkedCategory: 'necessary',
                        },
                    ],
                },
            },
            tr: {
                consentModal: {
                    title: "Merhaba gezgin, kurabiye zamanı!",
                    description: 'Web sitemiz, düzgün çalışmasını sağlamak için gerekli çerezleri kullanır.',
                    acceptAllBtn: 'Kabul et',
                    acceptNecessaryBtn: 'Reddet',
                    showPreferencesBtn: 'Tercihleri yönet',
                },
                preferencesModal: {
                    title: 'Çerez tercihleri',
                    acceptAllBtn: 'Tümünü kabul et',
                    acceptNecessaryBtn: 'Tümünü reddet',
                    savePreferencesBtn: 'Tercihleri kaydet',
                    sections: [
                        {
                            title: 'Kesinlikle gerekli çerezler',
                            description:
                                'Bu çerezler internet sitesinin çalışması amacıyla gerekli olan çerezlerdir. Söz konusu çerezler kullanıcının talep etmiş olduğu bir bilgi toplumu hizmetinin (log-in olma, form doldurma, gizlilik tercihlerinin hatırlanması gibi) yerine getirilebilmesi için zorunlu olarak kullanılmaktadırlar.',
                            linkedCategory: 'necessary',
                        },
                    ],
                },
            },
            dk: {
                consentModal: {
                    title: "Hej rejsende, det er kagetid!",
                    description:
                        'Vores hjemmeside bruger vigtige cookies for at sikre, at den fungerer korrekt.',
                    acceptAllBtn: 'Accepter',
                    acceptNecessaryBtn: 'Afvis',
                    showPreferencesBtn: 'Administrer præferencer',
                },
                preferencesModal: {
                    title: 'Indstillinger for cookies',
                    acceptAllBtn: 'Accepter alle',
                    acceptNecessaryBtn: 'Afvis alle',
                    savePreferencesBtn: 'Gem præferencer',
                    sections: [
                        {
                            title: 'Strengt nødvendige cookies',
                            description:
                                'Disse cookies er nødvendige for, at hjemmesiden kan fungere. Disse cookies bruges obligatorisk for at opfylde en informationssamfundstjeneste, som brugeren har anmodet om (såsom at logge ind, udfylde formularer, huske privatlivspræferencer).',
                            linkedCategory: 'necessary',
                        },
                    ],
                },
            },
        },
    },
};

export default defineNuxtPlugin(async (nuxtApp) => {
    // Set current language
    config.language.default = nuxtApp.$i18n.locale.value;

    // Listen for language switch
    nuxtApp.hook('i18n:localeSwitched', ({ oldLocale, newLocale }) => {
        CookieConsent.setLanguage(newLocale);
    })

    await CookieConsent.run(config);
    return {
        provide: {
            CC: CookieConsent,
        },
    };
});
